module.exports = "/_next/static/images/Trend04Visual@2x-c80c71d74361fd08e2aec500df327cc8.png";